import React from "react";

function About() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 21.2509H20.75V11.0009C20.75 8.58093 19.42 7.25093 17 7.25093H12.75V6.02093C13.33 6.16093 13.91 6.24093 14.5 6.24093C15.44 6.24093 16.38 6.06093 17.28 5.70093C17.56 5.59093 17.75 5.31093 17.75 5.00093V2.00093C17.75 1.75093 17.63 1.52093 17.42 1.38093C17.3184 1.31208 17.2017 1.26885 17.0798 1.25492C16.9579 1.24098 16.8345 1.25677 16.72 1.30093C15.29 1.87093 13.71 1.87093 12.28 1.30093C12.1655 1.25677 12.0421 1.24098 11.9202 1.25492C11.7983 1.26885 11.6816 1.31208 11.58 1.38093C11.37 1.52093 11.25 1.75093 11.25 2.00093V7.25093H7C4.58 7.25093 3.25 8.58093 3.25 11.0009V21.2509H2C1.59 21.2509 1.25 21.5909 1.25 22.0009C1.25 22.4109 1.59 22.7509 2 22.7509H22C22.41 22.7509 22.75 22.4109 22.75 22.0009C22.75 21.5909 22.41 21.2509 22 21.2509ZM7.24 21.2509H4.75V12.7509H7.24V21.2509ZM11.24 21.2509H8.74V12.7509H11.24V21.2509ZM15.24 21.2509H12.74V12.7509H15.24V21.2509ZM19.25 21.2509H16.74V12.7509H19.25V21.2509Z"
        fill="#FFBA88"
      />
    </svg>
  );
}

export default About;
